module.exports = __webpack_public_path__ + "20f1257895c2bedba8f4273e421eaa97.xml";


//////////////////
// WEBPACK FOOTER
// ./src/app/sitemap.xml
// module id = 30
// module chunks = 0